import FrontendProviderFactory from '@v2/services/flowsteps/FrontendProviderFactory';
import { asClass, asFunction, asValue } from 'awilix';
import { ValueConverterFactory } from 'shared/execution/workbook-api/converters';
import { CellFormatterFactory } from 'shared/execution/workbook-api/formatters';
import { appEventBus } from 'shared/infrastructure/app-event-bus';
import { diContainer } from 'shared/infrastructure/di-container';
import { OfficeJsWorkbookApi } from '../workbook-api/office-js-workbook-api';
import { FrontendAddressResolverFactory } from "@v2/services/runtime/frontend-address-resolver-factory";

diContainer.register({
  providerFactory: asClass(FrontendProviderFactory).singleton(),
  valueConverterFactory: asClass(ValueConverterFactory).singleton(),
  workbookApiFactory: asFunction(() => (context: any) => new OfficeJsWorkbookApi(context.workbookContext)),
  eventBus: asValue(appEventBus),
  addressResolverFactory: asClass(FrontendAddressResolverFactory).singleton(),
  cellFormatterFactory: asClass(CellFormatterFactory).singleton(),
});
